import type { RouteObject } from 'react-router';

import { EmptyFallback } from './components/EmptyFallback';
import { LocaleLayout } from './layouts/LocaleLayout';
import { MarketingLayout } from './layouts/MarketingLayout';
import { DocsPage } from './pages/marketing/DocsPage';
import { LandingPage } from './pages/marketing/LandingPage';
import { ModelsPage } from './pages/marketing/ModelsPage';
import { NotFoundPage } from './pages/marketing/NotFoundPage';
import { RootRedirect } from './pages/RootRedirect';

/**
 * Public pages (/:locale/...) are prerendered to HTML and indexed.
 * Private ones (/:locale/app/*, /admin/*) are lazy-loaded SPA chunks served from app.html.
 */
export const routes: RouteObject[] = [
  {
    path: '/',
    HydrateFallback: EmptyFallback,
    children: [
      { index: true, element: <RootRedirect /> },
      {
        path: 'admin/*',
        lazy: async () => ({ Component: (await import('./pages/admin/AdminPage')).AdminPage }),
      },
      {
        path: ':locale',
        element: <LocaleLayout />,
        children: [
          {
            element: <MarketingLayout />,
            children: [
              { index: true, element: <LandingPage /> },
              { path: 'models', element: <ModelsPage /> },
              { path: 'docs', element: <DocsPage /> },
              { path: '*', element: <NotFoundPage /> },
            ],
          },
          {
            path: 'app/*',
            lazy: async () => ({ Component: (await import('./pages/app/AppPage')).AppPage }),
          },
        ],
      },
    ],
  },
];
